import { Box, Button, type ButtonProps } from '@chakra-ui/react'
import { useLocation, useNavigate } from 'react-router';

interface Props extends ButtonProps {
  path: string,
  onClose?: () => void
}

const SidebarLink = (props: Props) => {
  const { children, path, onClose, ...buttonProps } = props;

  const location = useLocation();
  const navigate = useNavigate();
  
  const isCurrentPage = location.pathname.split('/painel')[1] === `/${path}`;

  const handleClick = () => {
    navigate(`/painel/${path}`);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Button
      variant="ghost"
      width="full"
      justifyContent="start"
      gap="3"
      color={isCurrentPage ? 'colorPalette.fg' : 'fg.muted'}
      _hover={{
        bg: 'colorPalette.subtle',
        color: 'colorPalette.fg',
      }}
      asChild
      onClick={handleClick}
      {...buttonProps}
    >
      <Box>
        {children}
      </Box>
    </Button>
  );
};

export default SidebarLink;
